import React, { useEffect, useContext } from "react";
import AppContext from "../contexts/AppContext";
import { setPageTitle } from "../actions";
import Header from "../components/header";
import ProjectList from "../components/project_list";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";

import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

import componentStyles from "../assets/styles/containers/project";
const useStyles = makeStyles(componentStyles);
const Project = () => {
  const { dispatch } = useContext(AppContext);
  const { t } = useTranslation();

  const classes = useStyles();

  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      setPageTitle(dispatch, t("label_project"));
    }
    getCurrentAuthenticatedUser();
  }, []);

  return (
    <>
      <Header />
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container justify="center">
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={t("label_project")}
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <ProjectList />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Project;
